import db from './db';
import { getStoreName } from './endpointMapper';
import { getUserIdFromToken as getUserIdFromJWT } from './jwtUtils';

  // ##### HELPER: Extract user_id from JWT token
function getUserIdFromToken() {
  const token = localStorage.getItem('access_token');
  const userId = getUserIdFromJWT(token);
  return userId;
}

// ##### LOAD FROM INDEXEDDB
// Generic function to load data from IndexedDB store
export const loadFromIndexedDB = async (storeName, params = {}) => {
  try {
    const store = db[storeName];
    if (!store) {
      throw new Error(`Store ${storeName} not found`);
    }

    const userId = getUserIdFromToken();
    if (!userId) {
      console.error('[offlineDataLoader] No userId found - throwing error');
      throw new Error('User not authenticated');
    }

    // Start query with user_id filter
    let query = store.where('user_id').equals(userId);

    // Apply additional filters from params
    if (params.date) {
      query = query.filter(item => item.date === params.date);
    }

    if (params.flow_type) {
      query = query.filter(item => item.flow_type === params.flow_type);
    }

    if (params.categ_l0) {
      query = query.filter(item => item.categ_l0 === params.categ_l0);
    }

    if (params.cluster_id !== undefined) {
      query = query.filter(item => {
        if (params.cluster_id === null) {
          return !item.cluster_id || item.cluster_id === null;
        }
        return item.cluster_id === params.cluster_id;
      });
    }

    const data = await query.toArray();

    // Return in API format (no ordering - frontend will handle it)
    return {
      results: data,
      count: data.length
    };
  } catch (error) {
    console.error(`Failed to load from IndexedDB store ${storeName}:`, error);
    throw error;
  }
};

// ##### LOAD FROM CACHE BY ENDPOINT
// Load data from cache using endpoint URL (similar to offlineInterceptor.handleGet)
export const loadFromCacheByEndpoint = async (url, params = {}) => {
  const storeName = getStoreName(url);
  if (!storeName) {
    throw new Error(`Endpoint not supported offline: ${url}`);
  }

  return await loadFromIndexedDB(storeName, params);
};

export default {
  loadFromIndexedDB,
  loadFromCacheByEndpoint
};
